<template>
  <div class="mt-5 md:mt-0 md:col-span-2">
    <Mutation
      :mutation="mutation"
      :variables="variables"
      :referchQueries="refetchQueries"
      @done="onDone"
      @error="onError"
    >
      <template v-slot="{ mutate, loading }">
        <ValidationObserver
          ref="observer"
          v-slot="{ valid, invalid }"
          tag="form"
          @submit.prevent="mutate"
        >
          <div class="shadow sm:rounded-md sm:overflow-hidden">
            <div class="px-4 py-5 bg-white sm:p-6">
              <div>
                <label for="email" class="block text-sm font-medium leading-5 text-gray-700">
                  Calls to {{ tpnDisplay }} will forward to
                </label>
                <div class="mt-1 flex">
                  <div class="relative flex-grow focus-within:z-10">
                    <input
                      id="email"
                      type="text"
                      class="form-input block w-full rounded-none rounded-l-md transition ease-in-out duration-150 sm:text-sm sm:leading-5 shadow-sm"
                      placeholder="(555) 987-6543"
                      v-model="proposedForwardingNumber"
                      tabindex="1"
                    />
                  </div>
                  <button class="ml-4 inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-cardstock-green-600 hover:bg-cardstock-green-500 focus:outline-none focus:border-cardstock-green-700 focus:ring-cardstock-green active:bg-cardstock-green-700 transition duration-150 ease-in-out" tabindex="1" :disabled="loading">
                    Save
                  </button>
                </div>
              </div>

            </div>
          </div>
        </ValidationObserver>
      </template>
    </Mutation>
  </div>
</template>

<script>
import _get from 'lodash-es/get'

import Mutation from '@/components/Mutation.vue'
import CurrentUserQuery from '@/queries/CurrentUser.gql'
import TeacherUpdateMutation from '@/mutations/TeacherUpdate.gql'
import { ValidationObserver, ValidationProvider } from "vee-validate"
import CurrentTeacherQuery from '@/queries/CurrentTeacher.gql'


export default {
  components: {
    Mutation,
    ValidationObserver
  },

  props: {
    teacher: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      proposedForwardingNumber: undefined,
      mutation: TeacherUpdateMutation,
      refetchQueries: () => { return [CurrentUserQuery, CurrentTeacherQuery] }
    }
  },

  computed: {
    variables() {
      return {
        id: _get(this, 'teacher.id'),
        forwardingNumber: this.proposedForwardingNumber
      }
    },

    tpnDisplay() {
      return _get(this, ['teacher', 'teacherPhoneNumbers', '0', 'formattedNumber'])
    }
  },

  methods: {
    onDone() {
      Bus.$emit('flash-message', {text: 'Forwarding number saved', type: 'success'})
    },

    onError(e) {
      Bus.$emit('flash-message', {text: e, type: 'error'})
    }
  },

  mounted() {
    this.proposedForwardingNumber = this.teacher.formattedForwardingNumber
  },

  watch: {
    teacher: function (newTeacher, oldTeacher) {
      this.proposedForwardingNumber = newTeacher.formattedForwardingNumber
    }
  }

}
</script>
